<template>
  <div
    style="width: 100%"
    @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
    @mouseleave="handleShowOperationBtn(false)"
  >
    <div class="top-nav-container">
      <div
        :class="{
          'top-nav   top-nav-fixed': props.componentData.fromType === 3,
          'top-nav   top-nav-absolute': props.componentData.fromType !== 3,
        }"
      >
        <div class="top-nav-web">
          <div
            class="top-nav-login-search"
            :style="{
              'background-color': configDataForm.topBackgroundColor,
            }"
          >
            <img
              :src="configDataForm.topImageFullUrl || noUpload"
              alt="顶部图片"
              loading="lazy"
            />
            <div class="search-link">
              <a
                target="_blank"
                :href="configDataForm.loginLinkUrl"
                class="login"
                :style="{
                  color: configDataForm.loginTextColor + ' !important',
                }"
                v-text="configDataForm.loginTextTitle"
              >
              </a>
              <a
                class="search"
                :href="configDataForm.searchLinkUrl"
                :style="{
                  color: configDataForm.searchTextColor + ' !important',
                }"
                v-text="configDataForm.searchTextTitle"
              >
              </a>
            </div>
          </div>

          <div
            :class="{
              'top-nav-menu-container': !isDarkLogoStyle && !isBackTopFlag,
              'top-nav-menu-container-deep': isDarkLogoStyle,
              'top-nav-menu-container-deep-home': isBackTopFlag,
            }"
          >
            <div class="top-nav-menu-logo">
              <a :href="indexHrefUrl"
                ><img
                  :src="leftLogoImageUrl || noUpload"
                  alt="Logo"
                  loading="lazy"
              /></a>
            </div>
            <div class="top-nav-menu-list">
              <span class="menu-close" @click="handleShowMoreMenu"> </span>
              <span
                v-for="item in columnList"
                :key="item.id"
                :class="{
                  active: item.id == activeIndex,
                  'top-nav-menu-list-item': true,
                }"
              >
                <a
                  v-if="item.children && item.children.length > 0"
                  :href="item.children[0].data.hrefURL"
                >
                  {{ item.label }}
                </a>
                <a v-else-if="item.data" :href="item.data.hrefURL">
                  {{ item.label }}
                </a>
                <div
                  v-if="item.children && item.children.length > 0"
                  class="sub-menu"
                >
                  <ul class="sub-nav">
                    <li></li>
                    <li
                      v-for="subitem in item.children"
                      :key="'su-el' + item.id + '-' + subitem.id"
                    >
                      <a v-if="subitem.data" :href="subitem.data.hrefURL">
                        {{ subitem.label }}
                      </a>
                    </li>
                  </ul>
                </div>
              </span>
            </div>

            <div class="top-nav-more-menu" @click="handleShowMoreMenu"></div>
            <operation-container
              v-if="showOperationBtn && !showEditForm"
              :component-data="props.componentData"
              :show-edit-content-button="props.showEditContentButton"
              :show-edit-components-button="props.showEditComponentsButton"
              :show-delete-components-button="props.showDeleteComponentsButton"
              :show-insert-components-button="props.showInsertComponentsButton"
              :show-sort-components-button="props.showSortComponentsButton"
              @handle-show-edit-form="handleShowEditForm"
              @handle-change-components="handleChangeComponents"
              @handle-delete-components="handleDeleteComponents"
              @handle-insert-components="handleInsertComponents"
              @handle-sort-components="handleSortComponents"
            ></operation-container>
          </div>
        </div>
        <div class="top-nav-mobile">
          <div
            :class="{
              'top-nav-menu-container': !isDarkLogoStyle && !isBackTopFlag,
              'top-nav-menu-container-deep': isDarkLogoStyle,
              'top-nav-menu-container-deep-home': isBackTopFlag,
            }"
            @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
            @mouseleave="handleShowOperationBtn(false)"
          >
            <div class="top-nav-menu-logo">
              <a :href="indexHrefUrl"
                ><img
                  :src="leftMobileLogoImageUrl || noUpload"
                  alt="Logo"
                  loading="lazy"
              /></a>
            </div>
            <div
              class="top-nav-menu-list-mask-layer"
              :class="{ show: showMobileMenuList }"
              @click="handleShowMoreMenu"
            ></div>
            <div
              class="top-nav-menu-list"
              :class="{ show: showMobileMenuList }"
            >
              <!-- [移动端优化-2026-03-09] 菜单头部Logo + 关闭按钮 -->
              <!-- 回滚：删除此 div.menu-header，恢复原始结构 -->
              <div class="menu-header">
                <a :href="indexHrefUrl" class="menu-logo">
                  <img
                    :src="leftMobileLogoImageUrl || noUpload"
                    alt="Logo"
                    loading="lazy"
                  />
                </a>
                <span class="menu-close" @click="handleShowMoreMenu"></span>
              </div>
              <!-- [移动端优化-2026-03-09] end -->
              <!-- [移动端优化-2026-03-09] 功能区：搜索+登录 -->
              <!-- 回滚：删除此 div.menu-actions -->
              <div class="menu-actions">
                <a
                  class="action-search"
                  :href="configDataForm.searchLinkUrl"
                  target="_blank"
                >
                  <span class="action-icon"></span>
                  <span class="action-text">{{ configDataForm.searchTextTitle }}</span>
                </a>
                <a
                  class="action-login"
                  :href="configDataForm.loginLinkUrl"
                  target="_blank"
                >
                  <span class="action-icon"></span>
                  <span class="action-text">{{ configDataForm.loginTextTitle }}</span>
                </a>
              </div>
              <!-- [移动端优化-2026-03-09] end -->
              <span
                v-for="item in mobileColumnList"
                :key="item.id"
                :class="{
                  active: item.id == activeIndex && item.showSubMenu,
                  'top-nav-menu-list-item': true,
                }"
              >
                <a
                  v-if="item.children && item.children.length > 0"
                  class="menu-item-text"
                  @click="handleToggleShowSubMenu(item)"
                >
                  {{ item.label }}
                </a>
                <a
                  v-else-if="item.data"
                  class="menu-item-text-single"
                  :href="item.data.hrefURL"
                >
                  {{ item.label }}
                </a>
                <div
                  v-if="item.children && item.children.length > 0"
                  class="sub-menu"
                >
                  <ul class="sub-nav">
                    <li
                      v-for="subitem in item.children"
                      :key="'su-el' + item.id + '-' + subitem.id"
                    >
                      <a v-if="subitem.data" :href="subitem.data.hrefURL">
                        {{ subitem.label }}
                      </a>
                    </li>
                  </ul>
                </div>
              </span>
            </div>
            <!-- [移动端优化-2026-03-09] 移除顶部重复的搜索/登录按钮 -->
            <!-- 回滚：恢复 <div class="mobile-search">...</div> -->
            <div class="top-nav-more-menu" @click="handleShowMoreMenu"></div>
            <!-- [移动端优化-2026-03-09] end -->
          </div>
        </div>
      </div>
      <div
        class="top-nav"
        :class="{
          'top-nav-deep': isDarkLogoStyle,
        }"
      ></div>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <top-nav-edit-form
        v-if="showEditForm"
        v-model="configDataFormModel"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></top-nav-edit-form>
    </el-drawer>
  </div>
</template>

<script setup>
// #region 引用
import useSSRInitialStateStore from '@/stores/ssr-state';
import TopNavEditForm from './TopNavEditFormTwo.vue';
import OperationContainer from '../common/OperationContainer.vue';

// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// 创建变量设默认值
const configDataForm = computed(() => {
  return JSON.parse(props.componentData.configData);
});
// 表单数据
const configDataFormModel = ref({});
// 是否移动菜单列表样式
const showMobileMenuList = ref(false);

const route = useRoute();
const ssrInitialState = useSSRInitialStateStore();
// 是否显示深色logo样式的菜单
const isDarkLogoStyle = computed(() => {
  // 默认显示浅色场景
  if (!route) {
    return false;
  }
  const routeName = [
    'website-home-preview',
    'website-website-home',
    'website-template-home',
    'website-preview-home',
  ]; // 首页默认显示深色场景
  return !routeName.includes(route.name);
});
// 返回顶部按钮显示
const isBackTopFlag = computed(() => {
  return ssrInitialState.backTopFlag;
});

// 左侧logo资源地址
const leftLogoImageUrl = computed(() => {
  return isDarkLogoStyle.value || ssrInitialState.backTopFlag
    ? configDataForm.value.leftDeepLogoImageFullUrl
    : configDataForm.value.leftLogoImageFullUrl;
});

const leftMobileLogoImageUrl = computed(() => {
  return configDataForm.value.leftLogoImageFullUrl;
});
// web栏目列表
const columnList = computed(() => {
  return configDataForm.value.columnList;
});

const curActiveIndex = ref(null);

// 默认选中key
const activeIndex = computed(() => {
  if (curActiveIndex.value) {
    return curActiveIndex.value;
  }

  if (configDataForm.value.activeIndex) {
    let id = configDataForm.value.activeIndex; // 没有子菜单的栏目id,就是选择当前栏目的id,有子菜单的就选择当前栏目下第一个子菜单的父级栏目id
    // 是点击选中下级菜单数据时，需要选中父级栏目id,而不是当前栏目的id,所以这里需要重新计算id值
    columnList.value.forEach((element) => {
      element.children.forEach((item) => {
        if (item.id === Number(configDataForm.value.activeIndex) && item.data) {
          id = item.data.parentId;
        }
      });
    });
    return `${id.toString()}`;
  }
  return columnList.value[0].id.toString();
});

// 首页链接
const indexHrefUrl = computed(() => {
  return columnList.value[0].data
    ? columnList.value[0].data.hrefURL
    : columnList.value[0].hrefURL;
});
// 移动端栏目列表
const mobileColumnList = computed(() => {
  return configDataForm.value.columnList.map((item) => {
    return {
      ...item,
      showSubMenu: item.id === Number(activeIndex.value),
    };
  });
});

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 切换子菜单显示状态
 *
 * @param item 子菜单项对象
 */
const handleToggleShowSubMenu = (item) => {
  item.showSubMenu = !item.showSubMenu;
  curActiveIndex.value = item.id.toString();

  if (!item.showSubMenu) {
    curActiveIndex.value = null;
  }
};

/**
 * 显示或隐藏更多菜单。
 *
 * @returns 无返回值。
 */
const handleShowMoreMenu = () => {
  showMobileMenuList.value = !showMobileMenuList.value;
};

// 操作显不显示编辑内容按钮
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataFormModel.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style lang="scss">
.top-nav-container {
  position: relative;
  width: 100%;

  .top-nav.top-nav-fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001; /* 需高于内容区组件的操作浮层(z-index:1000)，避免轮播图等覆盖导航栏导致悬停无法触发 */
  }

  .top-nav.top-nav-absolute {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1001; /* 需高于内容区组件的操作浮层(z-index:1000)，避免轮播图等覆盖导航栏导致悬停无法触发 */
  }
}
</style>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* 在屏幕宽度大于等于 1180px 时应用以下样式 */

/* PC端样式 */
@include pc {
  // 隐藏移动端菜单
  .top-nav-mobile {
    display: none;
  }
  //显示桌面端菜单
  .top-nav-web {
    display: block;
  }
  .top-nav {
    display: flex;
    flex-direction: column;
    width: 100%;
    transition: all 0.3s;

    .top-nav-login-search {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;
      font-family: SourceHanSansSC, sans-serif;
      font-size: 18px;
      img {
        height: 100%;
      }

      .search-link {
        position: absolute;
        top: 50%; /* 定位到容器顶部的50%位置 */
        right: 80px; /* 定位到容器右侧边缘 */
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transform: translateY(-50%); /* 向上移动自身高度的50%来居中对齐 */

        .login::after {
          margin-right: 30px;
          margin-left: 30px;
          content: '|';
        }
        .search {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: auto;
          height: 40px;
          padding-right: 20px;
          padding-left: 20px;
          line-height: 32px;
          white-space: nowrap;
          border: 1px solid rgb(255 255 255 / 30%);
          border-radius: 20px;
          transition: all $website-duration-normal $website-ease-out;

          &:hover {
            background-color: rgb(255 255 255 / 5%);
            border-color: rgb(255 255 255 / 50%);
          }
        }

        .search::after {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          color: #fff;
          content: '';
          background: url('image/search-icon.svg') no-repeat center center;
          background-size: cover;
        }
      }
    }
    .top-nav-menu-container-deep,
    .top-nav-menu-container-deep-home,
    .top-nav-menu-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 108px;
      background: url('image/head_bg.png') no-repeat center center;
      background-size: cover;
      transition: all 0.5s ease-in; /* 动画效果，持续0.5秒，缓动函数为ease */

      .top-nav-menu-logo {
        width: 460px;
        height: 80px;
        margin-left: 80px;

        img {
          height: 100%;
          object-fit: cover;
        }
      }
      //导航菜单
      .top-nav-menu-list {
        display: flex;
        flex-wrap: nowrap;
        margin-right: 80px;
        .top-nav-menu-list-item {
          position: relative;
          display: flex;
          // max-width: 140px;
          flex: auto;
          align-content: center;
          align-items: center;
          padding-bottom: 10px;
          margin: 18px 8px;
          font-family: '微软雅黑 Regular', '微软雅黑', sans-serif;
          font-size: 22px;
          font-style: normal;
          letter-spacing: 1px;
          cursor: pointer;

          a {
            color: #fff;
          }

          // 下级菜单样式
          .sub-menu {
            position: absolute;
            top: 36px;
            left: -9px;
            z-index: 2;
            display: none;
            min-width: 120px;
            background-color: #fff;
            box-shadow: 0 5px 8px rgb(0 0 0 / 10%);
            opacity: 0;
            transition: opacity 0.2s ease-in;

            ul {
              z-index: 10;
              width: 100%;
              li:first-of-type {
                height: 8px;
                background: $website-primary-light;
              }

              li:not(:last-of-type) {
                border-bottom: 1px solid #eff1f3;
              }

              li {
                z-index: 1;
                height: 36px;
              }

              li a {
                display: block;
                padding: 0 18px 0 21px;
                overflow: hidden;
                font-size: 18px;
                line-height: 36px;
                color: #000;
                text-align: left;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              li:not(:first-of-type):hover {
                color: #004399;
                background-color: #f6f6f6;
                a {
                  color: #004399;
                }
              }
            }
          }
        }

        .top-nav-menu-list-item.active {
          border-bottom: 4px solid $website-primary-light;
        }

        .top-nav-menu-list-item:hover {
          .sub-menu {
            display: block;
            opacity: 1;
          }
        }
      }
    }

    .top-nav-menu-container-deep {
      height: 88px;
      background: #fff;
      box-shadow: 0 2px 18px 0 rgb(0 0 0 / 5%);

      .top-nav-menu-logo {
        width: 400px;
        height: 60px;
        margin-right: 0;

        img {
          height: 100%;
          object-fit: cover;
        }
      }

      .top-nav-menu-list {
        .top-nav-menu-list-item {
          a {
            color: #373737;
          }
        }
      }
    }

    .top-nav-menu-container-deep-home {
      height: 88px;
      background: #fff;

      .top-nav-menu-logo {
        width: 400px;
        height: 60px;

        img {
          height: 100%;
          object-fit: cover;
        }
      }

      .top-nav-menu-list {
        .top-nav-menu-list-item {
          a {
            color: #373737;
          }
        }
      }
    }

    .top-nav-more-menu {
      display: none;
    }
  }

  .top-nav-deep {
    height: 152px;
  }
}

/* 在屏幕宽度小于等于 1180px 时应用以下样式 */

/* 移动端样式 */
@include mobile {
  // 显示移动端菜单
  .top-nav-mobile {
    display: block;
  }
  //隐藏桌面端菜单
  .top-nav-web {
    display: none;
  }
  .top-nav {
    width: 100% !important;
    min-width: auto !important;
    transition: all 0.3s;

    .top-nav-login-search {
      display: none;
    }

    .top-nav-menu-container-deep,
    .top-nav-menu-container-deep-home,
    .top-nav-menu-container {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      height: 16vw;
      margin: 0;
      background: url('image/head_bg.png') no-repeat center center;
      background-size: cover;
      transition: all 0.5s ease-in; /* 动画效果，持续0.5秒，缓动函数为ease */

      .top-nav-menu-logo {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 2vw;
        img {
          height: 8vw;
          margin-left: 2vw;
          object-fit: cover;
        }
      }

      .top-nav-menu-list-mask-layer {
        display: none;
        width: 100%;
        height: 100vh;
        background-color: #666;
        opacity: 0.6;
      }

      .top-nav-menu-list-mask-layer.show {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9998;
        display: block;
      }

      .top-nav-menu-list {
        display: none;
      }

      .top-nav-menu-list.show {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        // [移动端优化-2026-03-09] 全屏展示
        // 回滚：改为 width: 50vw;
        width: 100vw;
        // [移动端优化-2026-03-09] end
        height: 100vh;
        overflow-y: auto;
        // [移动端优化-2026-03-09] 毛玻璃效果
        // 回滚：改为 background-color: #194294; 删除 backdrop-filter
        background-color: rgb(25 66 148 / 92%);
        backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        // [移动端优化-2026-03-09] end
        // [移动端优化-2026-03-09] 动画优化
        // 回滚：改为 animation-name: fadeInTop; animation-duration: 0.2s;
        animation: slideInFromRight 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        // [移动端优化-2026-03-09] end

        // [移动端优化-2026-03-09] 关闭动画
        // 回滚：删除此样式块
        &.hiding {
          animation: slideOutToRight 0.25s cubic-bezier(0.4, 0, 1, 1);
        }
        // [移动端优化-2026-03-09] end

        // [移动端优化-2026-03-09] 菜单头部Logo + 关闭按钮 - 固定在顶部
        // 回滚：删除此样式块
        .menu-header {
          position: sticky;
          top: 0;
          z-index: 10;
          display: flex;
          flex-shrink: 0;
          align-items: center;
          justify-content: space-between;
          height: 16vw;
          padding: 2vw 4vw;
          background-color: rgb(25 66 148 / 95%);
          backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);

          .menu-logo {
            display: flex;
            align-items: center;

            img {
              height: 8vw;
              object-fit: contain;
            }
          }

          .menu-close {
            position: relative;
            top: auto;
            right: auto;
            display: flex;
            width: 8vw;
            height: 8vw;
            cursor: pointer;
            background: url('image/nav-close.png') no-repeat center center;
            background-color: rgb(255 255 255 / 10%);
            background-size: 60%;
            border-radius: 50%;
            transition:
              opacity 0.15s,
              transform 0.25s cubic-bezier(0, 0, 0.2, 1),
              background-color 0.15s;

            &:hover {
              background-color: rgb(255 255 255 / 20%);
              transform: rotate(90deg);
            }

            &:active {
              opacity: 0.6;
            }
          }
        }
        // [移动端优化-2026-03-09] end

        // [移动端优化-2026-03-09] 功能区：搜索框占满 + 登录固定宽度
        // 回滚：删除此样式块
        .menu-actions {
          display: flex;
          flex-shrink: 0;
          gap: 3vw;
          align-items: center;
          height: 14vw;
          padding: 0 4vw;
          background-color: rgb(0 0 0 / 15%);

          a {
            display: flex;
            gap: 2vw;
            align-items: center;
            height: 10vw;
            font-size: 4vw;
            font-weight: 500;
            color: #fff;
            border-radius: 2vw;
            transition:
              opacity 0.15s,
              transform 0.15s;

            &:active {
              opacity: 0.8;
              transform: scale(0.98);
            }

            .action-icon {
              width: 5vw;
              height: 5vw;
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
            }
          }

          .action-search {
            flex: 1;
            padding: 0 3vw;
            background-color: rgb(255 255 255 / 10%);

            .action-icon {
              background-image: url('image/search-icon.svg');
            }

            .action-text {
              color: rgb(255 255 255 / 70%);
            }
          }

          .action-login {
            flex-shrink: 0;
            justify-content: center;
            width: 22vw;
            background-color: rgb(255 255 255 / 15%);

            .action-icon {
              background-image: url('image/user-icon.svg');
            }
          }
        }
        // [移动端优化-2026-03-09] end

        .top-nav-menu-list-item {
          position: relative;
          display: flex;
          flex-direction: column;
          // [移动端优化-2026-03-09] 左对齐
          // 回滚：改为 align-items: center;
          align-items: flex-start;
          padding-left: 4vw;
          // [移动端优化-2026-03-09] end
          font-size: 4.5vw;
          // [移动端优化-2026-03-09] 分隔线优化
          // 回滚：改为 border-bottom: 0.25vw solid #0c327e;
          border-bottom: 1px solid rgb(255 255 255 / 6%);
          // [移动端优化-2026-03-09] end

          .menu-item-text-single,
          .menu-item-text {
            position: relative;
            display: flex;
            // [移动端优化-2026-03-09] 菜单项高度 + 整行可点击
            // 回滚：改为 align-items: center; height: 18vw; width: auto;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 16vw;
            padding-right: 4vw;
            // [移动端优化-2026-03-09] end
            font-weight: 700;
            color: #fff;
            cursor: pointer;
            // [移动端优化-2026-03-09] 触摸反馈
            // 回滚：删除 transition 和 &:active
            transition:
              background-color 0.15s,
              transform 0.15s;

            &:active {
              background-color: rgb(255 255 255 / 8%);
              transform: scale(0.98);
            }
            // [移动端优化-2026-03-09] end
          }

          .menu-item-text::after {
            // [移动端优化-2026-03-09] 箭头放到最右侧
            // 回滚：改为 position: relative; left: 20px; display: inline-block;
            position: absolute;
            right: 4vw;
            // [移动端优化-2026-03-09] end
            display: flex;
            width: 8px;
            height: 8px;
            content: '';
            border-right: 2px solid #fff;
            border-bottom: 2px solid #fff;
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            transform: rotate(45deg);
          }

          // 下级菜单样式
          .sub-menu {
            display: flex;
            // [移动端优化-2026-03-09] 左对齐 + 子菜单缩进
            // 回滚：改为 align-items: center; justify-content: center; width: 50vw; padding: 0;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            // [移动端优化-2026-03-09] end
            max-height: 0;
            padding-left: 4vw;
            overflow: hidden;
            color: #fff;
            background-color: rgb(0 0 0 / 10%);
            // [移动端优化-2026-03-09] 展开动画
            // 回滚：删除 transition 和 max-height
            transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            // [移动端优化-2026-03-09] end

            ul {
              // [移动端优化-2026-03-09] 宽度调整
              // 回滚：改为 width: 50vw;
              width: 100%;
              // [移动端优化-2026-03-09] end
              li:not(:last-of-type) {
                border-bottom: 1px solid rgb(255 255 255 / 5%);
              }

              li {
                display: flex;
                // [移动端优化-2026-03-09] 左对齐
                // 回滚：改为 align-items: center; justify-content: center; height: 18vw; margin: 0 8vw;
                align-items: center;
                justify-content: flex-start;
                height: 12vw;
                padding-left: 2vw;
                margin: 0;
                // [移动端优化-2026-03-09] end

                a {
                  font-size: 3.5vw;
                  transition: opacity 0.15s;

                  &:active {
                    opacity: 0.7;
                  }
                }
              }
            }
          }
        }

        .top-nav-menu-list-item.active {
          // [移动端优化-2026-03-09] 激活状态优化
          // 回滚：改为 border-bottom: 0.25vw solid #22cbf2;

          // 左侧强调条
          &::before {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 3px;
            content: '';
            background: #22cbf2;
            opacity: 0.8;
          }

          // 背景高亮
          background-color: rgb(34 203 242 / 10%);
          // [移动端优化-2026-03-09] end

          .menu-item-text {
            color: #22cbf2;
          }

          .sub-menu {
            max-height: 300px;
          }

          .menu-item-text::after {
            transform: rotate(-135deg);
          }
        }
      }

      // [移动端优化-2026-03-09] 移除 .mobile-search 样式
      // 回滚：恢复此样式块
      // .mobile-search { ... }
      // [移动端优化-2026-03-09] end

      // [移动端优化-2026-03-09] .top-nav-more-menu 直接定位到右侧
      // 回滚：恢复 margin-left: auto; 删除 position: absolute; right: 2vw; top: 50%; transform: translateY(-50%);
      .top-nav-more-menu {
        position: absolute;
        top: 50%;
        right: 2vw;
        display: flex;
        width: 10vw;
        height: 10vw;
        cursor: pointer;
        background: url('image/top-nav-menu-white.png') no-repeat center center;
        background-size: 100%;
        transition:
          opacity 0.15s,
          transform 0.25s;
        transform: translateY(-50%);

        &:hover {
          transform: translateY(-50%) scale(1.1);
        }

        &:active {
          opacity: 0.6;
        }
      }
      // [移动端优化-2026-03-09] end
    }

    .top-nav-menu-container-deep {
      background: #194294;
    }

    .top-nav-menu-container-deep-home {
      background: #194294;
    }
  }

  .top-nav-deep {
    height: 16vw;
  }
}
</style>
